'use client';

import { Button } from '@/shared/ui/core';
import { SECTION_HREFS } from '@/shared/constants/landing';
import { CaretUpIcon } from '@phosphor-icons/react/dist/ssr';
import { useEffect, useState } from 'react';
import styles from './go-to-top.module.scss';


export function GoToTop () {
    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        const topSection = document.querySelector(SECTION_HREFS.top);

        if (!topSection) return;

        const observer = new IntersectionObserver(
            ([ entry ]) => {
                setVisible(!entry.isIntersecting);
            },
            {
                threshold: 0,
            },
        );

        observer.observe(topSection);

        return () => observer.disconnect();
    }, []);

    const handleClick = () => {
        document.querySelector(SECTION_HREFS.top)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };

    if (!visible) return null;

    return (
        <Button
            variant='naked'
            onClick={ handleClick }
            className={ styles.button }
            aria-label="Go to top"
        >
            <CaretUpIcon size={ 20 }/>
        </Button>
    );
}
